import { Link } from "react-router-dom";

export default function NotFound() {
  return (
    <div>
      <h1>Không có trang này</h1>
      <p>Đường dẫn bạn mở không tồn tại hoặc đã đổi.</p>
      <Link className="nut" to="/cong-cu">
        Xem tất cả công cụ
      </Link>
    </div>
  );
}
